<template>
	<v-chip-group column multiple class="p-0" @change="setSelected">
		<template v-for="(doc, i) in chipsList">
			<v-chip :key="i" filter small color="primary" class="text-capitalize">
				{{ doc }}
			</v-chip>
			<v-divider v-if="i == 2" :key="i + 'dev'" vertical class="hidden-sm-and-down mx-2" />
		</template>
	</v-chip-group>
</template>

<script>
export default {
	props: {
		chipsList: { type: Array, required: true },
		onChangeChips: { type: Function, required: true },
	},
	methods: {
		setSelected(chips) {
			const labels = chips.map(chip => this.chipsList[chip]);
			this.onChangeChips(labels);
		},
	},
};
</script>
